module.exports = __webpack_public_path__ + "media/123.f10033e3.wav";